import React, { useState, useContext, useEffect } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { toast } from "react-toastify";
import AppContext from "../../context/AppContext";
import { IoEllipsisVerticalCircle } from "react-icons/io5";
import { RiGroupFill } from "react-icons/ri";
import CreateOrganization from "./CreateOrgnization";
import {
  fetchOrgnizationData,
  fetchOrganizationById,
  getAllByOrganizationId,
  getProjectList,
} from "../../service/User";
import Updateorgnization from "./Updateorgnization";
import { RxCross2 } from "react-icons/rx";
import { Spinner } from "../../Spinner";
import translations from "../common/Translations";
import CommonButton from "../common/CommonButton";
import ReactSelector from "../common/CommonReactSelector";
import actionImage from "../../assets/actionImage.png";
import CreateDepartment from "./CreateDeparment";
import CreateProject from "./CreateProject";
import {
  MdKeyboardDoubleArrowLeft,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";

const OrgnizationList = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalValue, setTotalValue] = useState(0);
  const [showEdit, setShowEdit] = useState(false);
  const [editUserId, setEditUserId] = useState(null); // Track which user's popup to show
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const totalPages = Math.ceil(totalValue / pageSize) - 1;
  const startIndex = currentPage * pageSize;
  const endIndex = startIndex + pageSize;
  const totalItems = totalValue;
  const { theme, langMode } = useContext(AppContext); // Use toggleTheme from contex
  const [open, setOpen] = useState(false);
  const [orgnizationData, setOrgnizationData] = useState([""]);
  const [orgnizationId, setOrgnizationID] = useState();
  const [editOrganizationname, setEditOrganizationName] = useState("");
  const [editOrganizationimg, setEditOrganizationImg] = useState(null);
  const [updateopen, setUpdateOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDepartment, setOpenDepartment] = useState(false);
  const [openProject, setOpenProject] = useState(false);
  const [getDeparment, setgeDeparment] = useState([]);
  const [projectData, setProjectData] = useState([]);
  const [deparmentId, setDeparmentId] = useState("");
  const [openOrganizationId, setOpenOrganizationId] = useState(null);

  const toggleOrganization = (orgId) => {
    setOpenOrganizationId((prevId) => (prevId === orgId ? null : orgId));
  };

  const totalPagesCount = Math.ceil(totalItems / pageSize);
  const paginationArray = Array.from({ length: totalPagesCount }, (_, index) =>
    (index + 1).toString()
  );
  const Popup = ({ onClose, onEdit, position, userId }) => {
    const adjustedPosition = {
      x: position.x - 80,
      y: position.y,
    };

    return (
      <div
        className="fixed bg-opacity-50 flex items-center justify-center top-2"
        style={{
          top: adjustedPosition.y,
          left: adjustedPosition.x < 0 ? 0 : adjustedPosition.x,
          width: "100px",
        }}
      >
        <div
          className={`bg-white rounded p-3 shadow-lg relative ${
            theme === "dark"
              ? "dark-mode border "
              : theme === "high-contrast"
              ? "high-contrast  "
              : ""
          }`}
          style={{ width: "80%" }}
        >
          <button
            className={`absolute top-0 right-0 p-1 text-sm ${
              theme === "dark"
                ? "dark-mode "
                : theme === "high-contrast"
                ? "high-contrast  "
                : ""
            }`}
            onClick={onClose}
          >
            <RxCross2 />
          </button>
          <button
            className={`text-black px-2 text-sm py-1  ${
              theme === "dark"
                ? "dark-mode "
                : theme === "high-contrast"
                ? "high-contrast  "
                : ""
            }`}
            onClick={() => onEdit(userId)}
          >
            {translations[langMode].edit}
          </button>
        </div>
      </div>
    );
  };

  const handleEditPopup = (Id, position) => {
    setOrgnizationID(Id);
    setPopupPosition(position);
    setShowEdit(true);
  };

  const closeEditPopup = () => {
    setShowEdit(false);
    setEditUserId(null);
  };
  const editInfo = async () => {
    setShowEdit(false);
    try {
      const ResponseData = await fetchOrganizationById(orgnizationId);
      setEditOrganizationName(ResponseData.data.body.value.organizationName);
      setEditOrganizationImg(ResponseData.data.body.value.logo);
      setUpdateOpen(true);
    } catch (error) {
      console.error("Error fetching organization data:", error);
      toast.error("Failed to fetch organization data");
    }
  };

  const tableHeaders = ["S.L", translations[langMode].OrganizationName, translations[langMode].source, "", translations[langMode].Action];

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.value, 10);
    setPageSize(size);
    setCurrentPage(0);
  };

  const goToPreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const fetchorgnizationlist = async () => {
    try {
      setLoading(true);
      const responseData = await fetchOrgnizationData(currentPage, pageSize);
      setOrgnizationData(responseData.data.body.value.organizationList);
      setTotalValue(responseData.data.body.value.totalSize);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching organization data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchorgnizationlist();
  }, [currentPage, pageSize]);

  useEffect(() => {
    const fetchDepartments = async () => {
      if (
        orgnizationData &&
        orgnizationData !== undefined &&
        orgnizationData.length > 0
      ) {
        const allDepartments = await Promise.all(
          orgnizationData.map(async (item) => {
            console.log("Fetching departments for:", item.organizationId);
            if (item.organizationId !== undefined) {
              return await getAllByOrganizationId(item.organizationId);
            }
          })
        );
        setgeDeparment(allDepartments.flat());
      }
    };

    fetchDepartments();
  }, [orgnizationData, currentPage, pageSize]);

  useEffect(() => {
    const fetchProjects = async () => {
      if (
        getDeparment &&
        getDeparment !== undefined &&
        getDeparment.length > 0
      ) {
        const allProjects = await Promise.all(
          getDeparment.map(async (item) => {
            console.log("Fetching Projects for:", item?.id);
            if (item?.id !== undefined) {
              return await getProjectList(item.id);
            }
          })
        );
        setProjectData(allProjects.flat());
      }
    };

    fetchProjects();
  }, [getDeparment, currentPage, pageSize]);

  const options = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  return (
    <div className="w-full ">
      <div
        className={`bg-white m-[11px] rounded-[10px]  ${
          theme === "dark"
            ? "dark-mode"
            : theme === "high-contrast"
            ? "high-contrast"
            : ""
        }`}
      >
        <div className="relative overflow-x-auto sm:rounded-lg ">
          {/* <div className="lg:px-5 py-5 flex justify-between items-center border borer-b-[#D1D5DB]">
            <div className="text-sm text-gray-400 flex items-center gap-2 lg:gap-4">
              <label
                className="font-normal text-base text-[#4B5563]"
                htmlFor="pageSize"
              >
                Show
              </label>
              <div className="w-[83px]">
                <ReactSelector
                  defaultValue={options?.find((item) => item.value == pageSize)}
                  options={options}
                  onChange={handlePageSizeChange}
                  height="40px !important"
                />
              </div>
            </div>

            <div className="flex justify-end gap-[10px] w-full">
              <button
                onClick={() => setOpen(true)}
                className=" max-w-[196px] w-full bg-[#236DB4] text-white text-base font-bold rounded-[5px] p-[12px] w-full"
              >
                Add Organization
              </button>
            </div>
          </div> */}
          <div className="lg:px-5 py-5 flex justify-end items-center border borer-b-[#D1D5DB]">
              <div className="flex justify-end gap-[10px] w-full">
                <button
                  onClick={() => setOpen(true)}
                  className=" max-w-[196px] w-full bg-[#236DB4] text-white text-base font-bold rounded-[5px] p-[12px] w-full"
                >

                  {translations[langMode].addOrganization}
                </button>
              </div>
          </div>

          <div className="lg:px-5 py-3 flex space-x-2 justify-end items-center">
            <div className="text-sm text-gray-400 flex items-center gap-2 lg:gap-4">
              <label htmlFor="pageSize">{translations[langMode].rows}</label>
              <div className="w-[83px]">
                <ReactSelector
                  defaultValue={options?.find((item) => item.value == pageSize)}
                  options={options}
                  onChange={handlePageSizeChange}
                  height="40px !important"
                />
              </div>
            </div>
          </div>

          <div className="overflow-x-auto mb-3">
            <div className="relative">
              <div className="overflow-y-auto" style={{ maxHeight: '400px' }}>
                <table className={`w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 ${
                  theme === "dark" 
                    ? "dark-mode" 
                    : theme === "high-contrast"
                    ? "high-contrast" 
                    : ""
                }`}>
                  <thead className={`text-sm sticky top-0 whitespace-nowrap ${
                    theme === "dark" 
                      ? "dark-mode border-b bg-gray-800 text-gray-300" 
                      : theme === "high-contrast" 
                      ? "high-contrast bg-gray-100" 
                      : "bg-gray-100 text-gray-800"
                  }`}>
                    <tr>
                      <th className="p-2 flex gap-[4px] items-center">
                        <input type="checkbox" />
                        S.L
                      </th>
                      <th className="p-2">{translations[langMode].OrganizationName}</th>
                      <th className="p-2">{translations[langMode].source}</th>
                      <th></th>
                      <th className="p-2 text-end">{translations[langMode].Action}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orgnizationData && orgnizationData.length > 0 ? (
                      orgnizationData.map((item, index) => (
                        <React.Fragment key={index}>
                          {/* Organization Row */}
                          <tr
                            className={`${
                              theme === "dark" 
                                ? "dark-mode bg-gray-700 border-gray-600" 
                                : theme === "high-contrast" 
                                ? "high-contrast bg-white" 
                                : "bg-white"
                            } border-b whitespace-nowrap`}
                            onClick={() => toggleOrganization(item.organizationId)}
                          >
                            <td className="p-2 flex gap-[7px] sm:mt-3 mt-2">
                              <input
                                type="checkbox"
                                onClick={() => {
                                  setOrgnizationID(item.organizationId);
                                }}
                              />
                             {index > 8 ? "" : 0}
                              {index + 1}
                            </td>
                            <td className="p-2">{item.organizationName}</td>
                            <td className="p-2">
                              {item.logo ? (
                                <img
                                  src={item.logo}
                                  alt={item.organizationName}
                                  className="h-10 w-10 rounded-full p-1"
                                />
                              ) : (
                                "No Logo"
                              )}
                            </td>
                            <td className="xsm:px-0 px-6">
                              <button
                                disabled={orgnizationId !== item.organizationId}
                                onClick={() => setOpenDepartment(true)}
                                className="max-w-[196px] w-full bg-[#236DB4] text-white text-base font-bold rounded-[5px] px-[12px] py-[8px]"
                              >
                                {translations[langMode].addDepartment}
                              </button>
                            </td>
                            <td>
                              <div
                                className="flex justify-end items-center mr-[20px]"
                                onClick={(event) =>
                                  handleEditPopup(item.organizationId, {
                                    x: event.clientX,
                                    y: event.clientY,
                                  })
                                }
                              >
                                <img src={actionImage} className="cursor-pointer" />
                              </div>
                            </td>
                          </tr>
                          {openOrganizationId === item.organizationId &&
                            (getDeparment || [])
                              .filter(
                                (department) =>
                                  department?.organizationId === item.organizationId
                              )
                              .map((department, depIndex) => (
                                <React.Fragment key={depIndex}>
                                  <tr className="hover:bg-[#EBF5FF] bg-white text-[#4B5563] text-[14px] border border-b-[#EBECEF]  h-[56px]">
                                    <td></td>
                                    <td className="pl-[30px]">
                                      {department?.name}
                                    </td>
                                    <td></td>
                                     <td className="xsm:ps-0 ps-6">
                                      <button
                                        onClick={() => {
                                          setDeparmentId(department?.id);
                                          setOpenProject(true);
                                        }}
                                        className="max-w-[129px] w-full bg-[#236DB4] text-white text-[14px] font-bold rounded-[5px] px-[12px] whitespace-nowrap py-[8px]"
                                      >
                                        Add Project
                                      </button>
                                    </td>
                                    <td>
                                      <div className="flex justify-end items-center mr-[20px]">
                                        <img
                                          src={actionImage}
                                          className="cursor-pointer"
                                        />
                                      </div>
                                    </td>
                                  </tr>

                                  {/* Project Rows */}
                                  {(projectData || [])
                                    .filter(
                                      (project) =>
                                        project?.departmentId === department?.id
                                    )
                                    .map((project, projIndex) => (
                                      <tr
                                        key={projIndex}
                                        className="hover:bg-[#EBF5FF] bg-white text-[#4B5563] text-[14px] border border-b-[#EBECEF] h-[56px]"
                                      >
                                        <td></td>
                                        <td className="pl-[60px]">
                                          {project?.name}
                                        </td>
                                        <td></td>
                                        <td></td>
                                        <td>
                                          {" "}
                                          <div className="flex justify-end items-center mr-[20px]">
                                            <img
                                              src={actionImage}
                                              className="cursor-pointer"
                                            />
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                </React.Fragment>
                              ))}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan={tableHeaders.length + 1}
                          className="text-center"
                        >
                          {translations[langMode].noOrg}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="my-4">
                <p className="text-xs text-gray-400 flex items-center gap-4">
                  {`${startIndex + 1}-${Math.min(endIndex, totalItems)} of ${totalItems} ${translations[langMode].items}`}
                  <IoIosArrowBack
                    onClick={goToPreviousPage}
                    disabled={currentPage === 0}
                    className={`cursor-pointer ${currentPage === 0 ? 'opacity-50' : ''}`}
                  />
                  <IoIosArrowForward
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    className={`cursor-pointer ${currentPage === totalPages ? 'opacity-50' : ''}`}
                  />
                </p>
              </div>
            </div>
            {/* {!orgnizationData.length <= 0 && (
              <div className="px-[15px] py-[24px] flex justify-between ">
                <div className="text-[#4B5563] text-sm font-normal">
                  Showing {startIndex} to {endIndex} of {totalItems} entries
                </div>
                <div className="flex items-center gap-[10px]">
                  <MdKeyboardDoubleArrowLeft
                    className="cursor-pointer"
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                    size={25}
                  />
                  <div className="flex gap-[10px]">
                    {(paginationArray || [])?.map((item) => (
                      <p
                        className={`w-[32px] h-[32px] rounded-[4px] flex justify-center items-center ${
                          currentPage === item
                            ? "bg-[#236DB4] text-[#FFFFFF]"
                            : "bg-[#EBECEF] text-[#4B5563]"
                        }`}
                        onClick={() => setCurrentPage(item)}
                      >
                        {item}
                      </p>
                    ))}
                  </div>
                  <MdOutlineKeyboardDoubleArrowRight
                    className="cursor-pointer"
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    size={25}
                  />
                </div>
              </div>
            )} */}
            <table
              // className={`w-full text-sm text-left rtl:text-right mt-2
              // ${theme === "dark"
              //     ? "dark-mode"
              //     : theme === "high-contrast"
              //       ? "high-contrast"
              //       : ""
              //   }`}
              className="hidden w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 overflow-y-auto relative z-0"
            >
              <thead
                // className={`text-sm bg-gray-100 text-gray-800  border border-b-[#EBECEF]
                // ${theme === "dark"
                //     ? "dark-mode"
                //     : theme === "high-contrast"
                //       ? "high-contrast"
                //       : ""
                //   }`}
                className="text-sm bg-[#F5F6FA] text-[#111827] border-b border-[#EBECEF] dark:text-gray-400"
              >
                <tr>
                  <th scope="col"></th>
                  {tableHeaders.map((header, index) => (
                    <th
                      key={index}
                      scope="col"
                      className={`px-6 py-3 text-xs text-[#111827] font-medium capitalize flex-nowrap ${
                        header === "S.L" ? "flex gap-[4px]" : ""
                      } 
                      ${header === "Action" ? "text-end" : "text-left"}`}
                    >
                      {header === "S.L" && (
                        <input
                          type="checkbox"
                          className={`w-4 h-4 text-blue-800 bg-gray-100 border-gray-300 rounded focus:ring-blue-800 dark:focus:ring-blue-800 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:border-gray-600 ${
                            theme === "dark"
                              ? "dark-mode"
                              : theme === "high-contrast"
                              ? "high-contrast"
                              : ""
                          }`}
                        />
                      )}
                      {header}
                    </th>
                  ))}
                  <th></th>
                </tr>
              </thead>
              <tbody className="overflow-y-auto max-h-[300px] h-auto">
                {orgnizationData && orgnizationData.length > 0 ? (
                  orgnizationData.map((orgnization, index) => (
                    <tr
                      key={index}
                      className={`bg-white ml-10 text-sm border-b justify-between border border-b-[#EBECEF]   ${
                        theme === "dark"
                          ? "dark-mode"
                          : theme === "high-contrast"
                          ? "high-contrast"
                          : ""
                      } `}
                    >
                      <td className="w-2 p-2"></td>
                      <td className="w-2 py-2 px-6 text-center items-center text-sm flex gap-[4px] ">
                        <input
                          type="checkbox"
                          className={`w-4 h-4 text-blue-800 bg-gray-100 border-gray-300 rounded focus:ring-blue-800 dark:focus:ring-blue-800 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800 focus:ring-2 dark:border-gray-600 ${
                            theme === "dark"
                              ? "dark-mode"
                              : theme === "high-contrast"
                              ? "high-contrast"
                              : ""
                          }`}
                        />
                        {index > 8 ? "" : 0}
                        {index + 1}
                      </td>
                      <td className="w-2 py-2  px-6 ">
                        <span className="flex px-4 py-1 ml-5 text-sm text-center text-[#4B5563]">
                          {" "}
                          {orgnization.organizationName}
                        </span>
                      </td>
                      <td className="w-2 py-3 px-6 text-center  ">
                        {orgnization.logo ? (
                          <img
                            src={orgnization.logo}
                            alt={orgnization.organizationName}
                            className="h-10 w-10 ml-8 border-2 border-gray-400 rounded-full p-1"
                          />
                        ) : (
                          "No Logo"
                        )}
                      </td>
                      <td></td>
                      <td className="pl-6 py-2 text-right">
                        <div
                          className="flex justify-end items-center"
                          onClick={(event) =>
                            handleEditPopup(orgnization.organizationId, {
                              x: event.clientX,
                              y: event.clientY,
                            })
                          }
                        >
                          <img src={actionImage} className="cursor-pointer" />
                          {/* <IoEllipsisVerticalCircle
                            size={20}
                            className="cursor-pointer text-blue-600"
                            onClick={(event) =>
                              handleEditPopup(orgnization.organizationId, {
                                x: event.clientX,
                                y: event.clientY,
                              })
                            }
                          /> */}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={tableHeaders.length + 1}
                      className="text-center"
                    >
                      {translations[langMode].noOrg}
                    </td>
                  </tr>
                )}
                {loading && <Spinner />}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showEdit && (
        <Popup
          onClose={closeEditPopup}
          onEdit={editInfo}
          position={popupPosition}
          userId={editUserId}
        />
      )}
      <CreateOrganization
        open={open}
        setOpen={setOpen}
        fetchorgnizationlist={fetchorgnizationlist}
      />

      <CreateDepartment
        open={openDepartment}
        organizationID={orgnizationId}
        setgetDeparment={setgeDeparment}
        setOpen={setOpenDepartment}
      />

      <CreateProject
        open={openProject}
        setProjectData={setProjectData}
        deparmentId={deparmentId}
        setOpen={setOpenProject}
      />

      <Updateorgnization
        setUpdateOpen={setUpdateOpen}
        fetchorgnizationlist={fetchorgnizationlist}
        updateopen={updateopen}
        setEditOrganizationName={setEditOrganizationName}
        editOrganizationname={editOrganizationname}
        setEditOrganizationImg={setEditOrganizationImg}
        editOrganizationimg={editOrganizationimg}
        orgnizationId={orgnizationId}
      />
    </div>
  );
};
export default OrgnizationList;
